import { useMutation } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { toast } from "react-toastify";
import api from "@/lib/api-client";

export const useResetPassword = () => {
    return useMutation({
        mutationFn: async (data) => {
            await api.put(`/Account/Password`, null, {
                params: { email: data.email },
            });
        },
        onSuccess: () => {
            toast.success("Email successfully sent!");
        },
        onError: (err) => {
            toast.error("Something went wrong");
            Sentry.captureException(err);
        },
        retry: false,
    });
};
